import "./CompositionInstaller";
import Vue from "vue";
import "animate.css";

import vuetify from "../vuetify";
import "vuetify/dist/vuetify.min.css";
import { ToastPlugin, ModalPlugin, BootstrapVue } from "bootstrap-vue";
import router from "./router";
import store from "./store";
import App from "./App.vue";
// Global Components
import "./global-components";

// 3rd party plugins
import "@axios";

import VueGoodTablePlugin from "vue-good-table";

// import the styles
import "vue-good-table/dist/vue-good-table.css";

import "@/libs/acl";
import "@/libs/portal-vue";
import "@/libs/toastification";
import "@/libs/sweet-alerts";
import "@/libs/vue-select";
import "@/libs/tour";
// Axios Mock Adapter
import "@/@fake-db/db";
// Composition API
// Vue.use(VueCompositionAPI)
// BSV Plugin Registration
Vue.use(ToastPlugin);
Vue.use(ModalPlugin);
Vue.use(VueGoodTablePlugin);

// Feather font icon - For form-wizard
// * Shall remove it if not using font-icons of feather-icons - For form-wizard
require("@core/assets/fonts/feather/iconfont.css"); // For form-wizard

// import core styles
require("@core/scss/core.scss");

// import assets styles
require("@/assets/scss/style.scss");

Vue.config.productionTip = false;

new Vue({
  vuetify,
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
